import { Injectable } from '@angular/core';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { RuoliOperatoriService } from 'app/main/ruoli-operatori-folder/ruoli-operatori.service';
import { BehaviorSubject } from 'rxjs';



@Injectable({ providedIn: 'root' })
export class PermissionsService {
    private userRoles: Set<string>;
    private _power = new BehaviorSubject<number>(0);

    constructor(private fuseNavigation: FuseNavigationService) { }

    get permissionConfig() {
        return this._permissionConfig;
    }
    get power() {
        return this._power;
    }

    getRolePower(ruolo: string) {
        switch (ruolo) {
            case 'Admin': return 3;
            case 'StudioAdmin': return 2;
            case 'StudioUser': return 1;
            default: return 0;
        }
    }
    manageNavigations(ruoli: string[] | string) {
        let power: number;
        if (Array.isArray(ruoli)) {
            power = Math.max(...ruoli.map(ruolo => this.getRolePower(ruolo)));
        }
        if (typeof ruoli === 'string') {
            power = this.getRolePower(ruoli);

        }

        this.fuseNavigation.updateNavigationItem('logs', { hidden: power < 3 });
        this.fuseNavigation.updateNavigationItem('gestioneCredenzialiAe', { hidden: power < 3 });
        this.fuseNavigation.updateNavigationItem('gestione-invii', { hidden: power < 3 });
        this.fuseNavigation.updateNavigationItem('cassetti-fiscali-da-controllare', { hidden: power < 2 });
        this.fuseNavigation.updateNavigationItem('ruoli-operatori', { hidden: power < 3 });
        this._power.next(power);
        this.userRoles = new Set(ruoli);
    }



    private _permissionConfig = {
        "invioNotificaPush": { "permittedRoles": ["Admin", "StudioAdmin"] },
        "uploadF24": { "permittedRoles": ["StudioAdmin", "Admin"] },
        "forfettariInAttivazione": { "permittedRoles": ["Admin", "StudioAdmin"] },
        "forfettariInRegistrazione": { "permittedRoles": ["Admin", "StudioAdmin"] },
        "schedaForfettario": { "permittedRoles": ["Admin", "StudioAdmin"] },
    };




    doCheckAuthorization(functionId: string) {
        if (functionId) {
            const entry = this._permissionConfig[functionId];
            if (entry && entry['permittedRoles'] && this.userRoles.size) {
                return entry.permittedRoles
                    .some(permittedRole => this.userRoles.has(permittedRole));
            }
            return false;
        }
        return false;
    }


}
